import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_INQ007_Request,
  IAPI_INQ007_Response,
} from "../../../type/apiType";

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

// 原簿閲覧請求登録参照
const httpAPI_INQ007 = async (
  param: IAPI_INQ007_Request
): Promise<IAPI_INQ007_Response> => {
  let res = await http.post(ApiUrl.API_INQ007, {
    ...param,
  });
  return res.data;
};

export { httpAPI_INQ007, httpAPI_APP016 };
